'use strict';

const PARTNERS = ['appsumo', 'stackcommerce', 'appsumo-starter'];
const PARTNERCODEVALIDITY = 15;
const PARTNERCODES = {
  stackcommerce: ['STACKCOMMERCE2020'],
};
const PARTNER_FEES = {
  'appsumo-starter': 0,
};

const getPartners = () => PARTNERS;
const getPartnersFees = () => PARTNER_FEES;
const getPartnerCodesValidity = () => PARTNERCODEVALIDITY;
const getAllPartnerCodes = () =>
  Object.values(PARTNERCODES).reduce((acc, codes) => acc.concat(codes), []);
const getPartnerCodes = partner => PARTNERCODES[partner] || [];

module.exports = {
  getPartners,
  getPartnersFees,
  getPartnerCodesValidity,
  getAllPartnerCodes,
  getPartnerCodes,
};
